import { eOnlineSearchLevel } from '@/types/SalesPersons';
import { z } from 'zod';

export const getSalesPersonByIdSchema = z.object({
  id: z.string(),
  code: z.string(),
  name: z.string(),
  companySite: z.object({
    id: z.string(),
    companyID: z.string(),
    name: z.string(),
  }),
  userID: z.string(),
  mwSalesPersonType: z
    .object({
      id: z.string(),
      code: z.string(),
      name: z.string(),
      isActive: z.boolean(),
      isFromManager: z.boolean(),
      boid: z.string().optional(),
    })
    .optional(),
  sequence: z.number(),
  rootCode: z.string(),
  isActive: z.boolean(),
  isFromManager: z.boolean(),
  boid: z.string().optional(),
  onlineSearchLevel: z.nativeEnum(eOnlineSearchLevel),
  salesPersonParentId: z.string().optional(),
  mwSalesPersonsAccessMaxLevel: z
    .object({
      id: z.string(),
      level: z.number(),
      name: z.string(),
    })
    .optional(),
  companySiteID: z.string(),
  mwSalesPersonTypeID: z.string(),
  mwSalesPersonsAccessMaxLevelID: z.string().optional(),
  user: z.object({
    id: z.string(),
    userName: z.string(),
  }),
});

export type GetSalesPersonByIdSchema = z.infer<typeof getSalesPersonByIdSchema>;
